"use strict";
/** @module AccountApi */
Object.defineProperty(exports, "__esModule", { value: true });
var device_1 = require("../functions/device");
/**
 * Mixin class for account/join site account API calls.
 */
var AccountMixin = /** @class */ (function () {
    function AccountMixin() {
    }
    /**
     * Signs up new user.
     * @TODO I have no idea what this will be returning right now.
     * @param email
     * @param password
     * @param givenName
     * @param surname
     * @param phone
     * @param callback
     */
    AccountMixin.prototype.signUp = function (email, password, givenName, surname, phone, callback) {
        var _this = this;
        var body = {
            appVersion: this.version,
            deviceId: this.local.deviceId,
            deviceName: device_1.getDeviceName(this.siteName),
            deviceType: this.platform,
            deviceInfo: device_1.getDeviceInfo(),
            timezone: 300,
            email: email,
            password: password,
            givenName: givenName,
            surname: surname,
        };
        if (phone) {
            body.phone = phone;
        }
        var wrappedCallback = function (request, response) {
            _this.authCallback(request, response, callback);
        };
        this.http.post('/users', null, body, wrappedCallback);
    };
    return AccountMixin;
}());
exports.default = AccountMixin;
//# sourceMappingURL=AccountMixin.js.map